import { getCorrelationId as f, getRumShim as g, isRumEnabled as I, logSuppressedError as p, readSessionIdFromCookie as S, setCorrelationId as v, toError as E } from "../../helpers/datadog.helper.js";
import { useWebStore as l } from "../../store/webStore.js";
import { classifyReportableError as C } from "../../helpers/expectedError/expectedError.helper.js";
import { useCallback as b } from "react";
var D = (r) => E(r), h = () => process.env.NODE_ENV !== "production", x = () => {
  try {
    const r = l.getState().user;
    return r?.id != null ? String(r.id) : void 0;
  } catch {
    return;
  }
}, N = () => {
  try {
    const r = l.getState().user;
    return r?.customerId != null ? String(r.customerId) : void 0;
  } catch {
    return;
  }
}, A = (r) => ({
  trace: b((n, o) => {
    const t = D(n);
    if (h()) {
      const m = o ? [` ${JSON.stringify(o)}`] : [];
      console.debug(`[ DataDog Debug ] ${t.message}`, t, ...m);
    }
    const e = {}, a = S();
    a && (e.sessionId = a);
    const d = f();
    d && (e.correlationId = d);
    const s = x();
    s && (e.userId = s);
    const c = N();
    c && (e.patientId = c);
    const i = C({
      error: n,
      ...s ? { isAuthenticated: !0 } : {}
    }), u = {
      ...e,
      ...r ? { boundary: r } : {},
      ...o
    };
    if (i.expected) {
      p(t, {
        ...u,
        ...i.context
      }, i.level);
      return;
    }
    I() && g().addError(t, u);
  }, [r]),
  setCorrelationId: v
});
export {
  A as useDatadog
};

//# sourceMappingURL=useDatadog.js.map